<template>
  <div>
    <a-card style="margin: 20px">
      <template #title>
        <div class="top-title" style="display: flex; justify-content: space-between; align-items: center;">
          <div class="left">
            <span>提现记录</span>
          </div>

          <div class="right-flex" style="margin-right: 20px;">
            <div class="statistics-summary">
              <div>
                <p>提现总额：￥{{ statisticsData?.totalLimit || 0.00 }}</p>
              </div>
              <div style="margin-left: auto;">
                <!--          <a-button type="primary" @click="handleSyncAll" v-if="$authority('invoiceSyncAll')">-->
                <!--            全量同步-->
                <!--          </a-button>-->
              </div>
            </div>
          </div>
        </div>
      </template>


      <!-- 筛选区域 -->
      <div class="selectBox">
        <div class="selectBox">
          <!-- 机构ID -->
          <div class="selected-box-item">
            <span class="left-item">机构ID</span>
            <DepartmentChoose :department-code.sync="searchForm.departmentCode"
                              @change="handleQuery"></DepartmentChoose>
          </div>
          <div class="selected-box-item">
            <span class="left-item">渠道:</span>
            <a-select v-model="searchForm.channelNo" placeholder="请选择渠道" allowClear style="width: 200px">
              <a-select-option v-for="item in companylist" :key="item.value" :value="item.value">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </div>
          <div class="selected-box-item">
            <span class="left-item">下单日期</span>
            <a-range-picker valueFormat="YYYY-MM-DD" v-model.trim="time" @change="onChange" style="width: 200px"/>
          </div>

          <div class="selected-box-item">
            <span class="left-item">业务流水号:</span>
            <a-input v-model="searchForm.serialNo" placeholder="请输入业务流水号" allowClear style="width: 200px"/>
          </div>

          <div class="selected-box-item">
            <span class="left-item">提现结果:</span>
            <a-select placeholder="请选择提现结果" v-model.trim="searchForm.result" style="width: 200px" allowClear>
              <a-select-option value="SUCCESS">
                <a-tag color="green">成功</a-tag>

              </a-select-option>
              <a-select-option value="FAIL">
                <a-tag color="red">失败</a-tag>

              </a-select-option>
            </a-select>

          </div>
          <div class="selected-box-item">
            <span class="left-item">提现账户号:</span>
            <a-input v-model="searchForm.accountNo" placeholder="请输入提现账户号" allowClear style="width: 200px"/>
          </div>
          <div class="selected-box-item">
            <span class="left-item">银行账卡号:</span>
            <a-input v-model="searchForm.primaryAccount" placeholder="请输入银行账卡号" allowClear style="width: 200px"/>
          </div>
        </div>

      </div>

      <!-- 表格部分 -->
      <div class="tableBox">
        <div class="handleBtn">
          <a-button type="primary" @click="handleQuery">查询</a-button>
          <a-button style="margin-left: 10px" @click="handleReset">重置</a-button>

        </div>
        <div class="tableBody">
          <a-table :columns="columns" :data-source="tableData" :pagination="false">
            <template slot="resultTag" slot-scope="text, record">
              <a-popover v-if="text && text.toUpperCase() !== 'SUCCESS' && record.failReason" placement="top">
                <template slot="content">
                  {{ record.failReason }}
                </template>
                <a-tag color="red">
                  失败
                </a-tag>
              </a-popover>

              <a-tag v-else :color="text && text.toUpperCase() === 'SUCCESS' ? 'green' : 'red'">
                {{ text && text.toUpperCase() === 'SUCCESS' ? '成功' : '失败' }}
              </a-tag>
            </template>


          </a-table>
        </div>
      </div>

      <!-- 分页部分（保持原样） -->
      <div class="paginationBox">
        <a-button :disabled="paramsData.pageNo === 1" @click="Homepage">首页</a-button>
        <a-pagination
            v-model.trim="paramsData.pageNo"
            :page-size-options="pageSizeOptions"
            :total="total"
            show-size-changer
            :page-size="paramsData.pageSize"
            @change="pagechange"
            @showSizeChange="onShowSizeChange"
            :item-render="itemRender"
        />
        <a-button
            @click="Trailingpage"
            :disabled="paramsData.pageNo === Math.ceil(total / paramsData.pageSize)"
            class="Trailingpage"
        >尾页
        </a-button>
      </div>
    </a-card>
  </div>
</template>

<script>
import {message} from "ant-design-vue";
import Balance from '@/view/components/Balance.vue';
import WalletInfo from '@/view/components/WalletInfo.vue';
import DepartmentChoose from "@/view/components/DepartmentChoose.vue";
import DeptInfo from "@/view/components/DeptInfo.vue";
import {handleChannelNo} from "@/utils/commonMethods";

export default {
  name: 'withdrawRecord',
  components: {DepartmentChoose, DeptInfo, Balance, WalletInfo},
  data() {
    return {
      companylist: [],
      tableData: [],
      pageSizeOptions: ["10", "20", "30", "40", "50"],
      total: 0,
      time: [], // 时间

      searchForm: {
        channelNo: undefined,
        serialNo: '',
        accountNo: '',
        accountName: '',
        primaryAccount: '',
        result: 'SUCCESS',
        startTime: '',
        endTime: '',
        departmentCode: '',
      },
      statisticsData: {},

      paramsData: {
        pageNo: 1,
        pageSize: 10,
      },
      columns: [
        {
          title: "No",
          align: "center",
          width: 60,
          customRender: (text, record, index) =>
              `${(this.paramsData.pageNo - 1) * this.paramsData.pageSize + (index + 1)}`,
        },
        {
          title: '渠道',
          dataIndex: 'channelNo',
          align: 'center',
          width: 60,
          ellipsis: true,
          customRender: (text) => {
            return handleChannelNo(JSON.parse(this.$session.getItem('coreCompanyList')), text, '1');
          },
        },
        {
          title: '业务流水号',
          dataIndex: 'serialNo',
          align: 'center',
          width: 60,
        },
        {
          title: '提现账户号',
          dataIndex: 'accountNo',
          align: 'center',
          width: 60,
          customRender: (text, row) => {
            return text
                ? <WalletInfo showAccountName={true} showAccountNo={false} accountNo={row.accountNo} accountName={row.accountName} accountClass="1"
                              showBalance={true}/>
                : "";
          },
        },
        {
          title: "银行账卡号",
          dataIndex: "primaryAccount",
          align: "center",
          width: 60,
          ellipsis: true,
          customRender: (text, row) => {
            return text
                ? <WalletInfo isWallet={false} accountNo={row.primaryAccount} accountName={row.accountName}/>
                : "";
          },
        },
        {
          title: "提现金额",
          dataIndex: "amount",
          align: "center",
          width: 60,
          customRender: (text) => <Balance amount={text}/>
        },
        {
          title: "交易摘要",
          dataIndex: "transSummary",
          align: "center",
          width: 120,
        },
        {
          title: "提现结果",
          dataIndex: "result",
          align: "center",
          width: 80,
          scopedSlots: {customRender: "resultTag"},
        },
        {
          title: "交易时间",
          dataIndex: "createTime",
          align: "center",
          ellipsis: true,
          width: 60,
          customRender: (text) => text ? text.replace('T', ' ') : "---",
        },
      ],
    };
  },
  mounted() {
    this.getChannelList();
    this.getTableData();
  },
  methods: {
    handleChannelNo,

    async getChannelList() {
      try {
        const res = await this.api.coreCompanyInfoApi();
        if (res.code === 200) {
          this.companylist = res.data.map(item => ({
            label: `${item.channelName}（${item.channelNo}）`,
            value: item.channelNo,
            info: item,
          }));
          if (this.companylist.length === 1) {
            this.formData.channelNo = this.companylist[0].value;
            this.channelChange(this.formData.channelNo);
          }
        } else {
          this.$message.error(res.info || "获取渠道列表失败");
        }
      } catch {
        this.$message.error("获取渠道列表异常");
      }
    },

    channelChange(val) {
      const selected = this.companylist.find(item => Number(val) === Number(item.value));
      if (selected) {
        this.addFormData.appNo = selected.info.appNo;
      }
    },

    async getTableData() {
      const data = {
        pageNo: this.paramsData.pageNo,
        pageSize: this.paramsData.pageSize,
        ...this.searchForm
      };
      const res = await this.api.withdrawPageApi(data);
      if (res.code === 200) {
        this.tableData = res.data.records;
        this.total = res.data.total;
        const res2 = await this.api.withdrawStatisticsApi(data);
        if (res2.code === 200) {
          this.statisticsData = res2.data;
        }


      } else {
        message.warning(res.info);
      }
    },

    onChange(value) {
      this.searchForm.startTime = value[0] + " 00:00:00"
      this.searchForm.endTime = value[1] + " 23:59:59"
    },

    handleQuery() {
      this.paramsData.pageNo = 1;
      this.getTableData();
    },
    handleReset() {
      this.searchForm = {
        channelNo: undefined,
        appNo: '',
        serialNo: '',
        accountNo: '',
        accountName: '',
        result: '',
        primaryAccount: '',
        startTime: '',
        endTime: '',
        departmentCode: '',
      };
      this.paramsData.pageNo = 1;
      this.getTableData();
    },


    onShowSizeChange(current, pageSize) {
      this.paramsData.pageNo = current;
      this.paramsData.pageSize = pageSize;
      this.getTableData();
    },

    pagechange(val) {
      this.paramsData.pageNo = val;
      this.getTableData();
    },

    Homepage() {
      if (this.total > 0) {
        this.paramsData.pageNo = 1;
        this.getTableData();
      }
    },

    Trailingpage() {
      if (this.total > 0) {
        this.paramsData.pageNo = Math.ceil(this.total / this.paramsData.pageSize);
        this.getTableData();
      }
    },

    itemRender(current, type, originalElement) {
      if (type === "prev") return <a>上一页</a>;
      if (type === "next") return <a>下一页</a>;
      return originalElement;
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .ant-card-body {
  padding: 24px 34px;
}

.selectBox {
  display: flex;
  flex-wrap: wrap;

  /deep/ .selected-box-item {
    margin: 0 20px 20px 0;
    width: 280px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left-item {
      margin-right: 15px;
    }

    .ant-input {
      width: 200px;
    }

    .ant-select-selection--single {
      width: 200px;
    }
  }

  /deep/ .item {
    margin-bottom: 20px;
    margin-right: 20px;

    .ant-input,
    .ant-select {
      width: 200px;
      margin-left: 20px;
    }
  }
}

.tableBox {
  margin-bottom: 20px;

  .handleBtn {
    margin-bottom: 20px;
  }
}

.paginationBox {
  display: flex;
  justify-content: flex-end;

  .ant-pagination-prev,
  .ant-pagination-next,
  .ant-pagination-jump-prev,
  .ant-pagination-jump-next {
    border: 1px solid #d9d9d9;
    width: 60px;
  }
}
</style>
